module.exports = __webpack_public_path__ + "assets/img/34ca-sg.svg";